import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=00815fd5&scoped=true&"
import script from "./SignUp.vue?vue&type=script&lang=js&"
export * from "./SignUp.vue?vue&type=script&lang=js&"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=00815fd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00815fd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00815fd5')) {
      api.createRecord('00815fd5', component.options)
    } else {
      api.reload('00815fd5', component.options)
    }
    module.hot.accept("./SignUp.vue?vue&type=template&id=00815fd5&scoped=true&", function () {
      api.rerender('00815fd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/SignUp.vue"
export default component.exports